module.exports = __webpack_public_path__ + "fonts/heebo-v9-latin-regular.101df1a3.woff2";